/* Sampling — moved out of pages/Sampling.jsx in split step 6d (28-Oct-2026), unchanged. */
import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { fmtNumber } from "@/components/Amount";   // STEP 3 · rule 2 · B-2e: the one amount formatter

// ------------------------------------------------------------------
// Read-only mirror of a Materiality-tab value. Visually distinct from
// a real input (locked icon, gray/tinted bg, cursor-not-allowed) and
// carries a "from Materiality tab" caption with a deep-link so users
// know the one place to change it.
// ------------------------------------------------------------------
function LockedFromMateriality({ value, testid }) {
  const { t } = useI18n();
  // Batch A · fix (7) — Western digits + separators, both locales.
  const NF = { format: (n) => fmtNumber(n) };   // STEP 3 · rule 2 · B-2e
  const display = NF.format(Number(value || 0));
  const isZero = !value || Number(value) === 0;
  return (
    <div>
      <div
        data-testid={testid}
        data-locked="true"
        aria-readonly="true"
        title={t("sampling.lockedTitle")}
        className="flex h-10 items-center justify-between rounded-md border border-slate-200 bg-slate-100 px-3 text-sm text-slate-700 cursor-not-allowed dark:border-slate-700 dark:bg-slate-800/60 dark:text-slate-200"
      >
        <span className={isZero ? "text-slate-400" : "font-medium"}>
          {isZero ? t("sampling.notSetYet") : display}
        </span>
        <Lock className="h-3.5 w-3.5 text-slate-400" />
      </div>
      <div className="mt-1 flex items-center gap-1 text-[10px] text-emerald-700">
        <Lock className="h-2.5 w-2.5" />
        <Link to="/planning?openForm=materiality" className="underline hover:text-emerald-800" data-testid={`${testid}-goto`}>
          {t("sampling.editIn105a")}
        </Link>
      </div>
    </div>
  );
}

export { LockedFromMateriality };
